'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import Controllable from '../decorators/Controllable';
import SyntheticEvent from '../core/SyntheticEvent';
import UILink from '../link/UILink';
import UIControlledPopover from './UIControlledPopover';

class UIHelpLink extends Component {
  constructor(...args) {
    super(...args);

    this.handleLinkClick = evt => {
      const {
        disabled,
        onClick,
        onOpenChange,
        open
      } = this.props;
      if (disabled) return;
      if (onClick) onClick(evt);

      if (!evt.defaultPrevented) {
        onOpenChange(SyntheticEvent(!open));
      }
    };
  }

  render() {
    const _this$props = this.props,
          {
      children,
      className,
      disabled,
      href,
      open
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "disabled", "href", "onClick", "open"]);

    return /*#__PURE__*/_jsx(UIControlledPopover, Object.assign({}, rest, {
      open: !disabled && open,
      use: "longform",
      children: /*#__PURE__*/_jsx(UILink, {
        className: className,
        href: href,
        onClick: this.handleLinkClick,
        disabled: disabled,
        children: children
      })
    }));
  }

}

UIHelpLink.propTypes = {
  children: UILink.propTypes.children,
  content: UIControlledPopover.propTypes.content,
  disabled: PropTypes.bool,
  href: UILink.propTypes.href,
  onOpenChange: UIControlledPopover.propTypes.onOpenChange,
  open: UIControlledPopover.propTypes.open,
  placement: UIControlledPopover.propTypes.placement,
  showCloseButton: UIControlledPopover.propTypes.showCloseButton
};
UIHelpLink.defaultProps = {
  disabled: false,
  open: false,
  placement: 'top',
  showCloseButton: false
};
UIHelpLink.displayName = 'UIHelpLink';
export default Controllable(UIHelpLink, ['open']);